import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';
import { AppProviders, createQueryClient } from './app/providers';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { storeToken } from './lib/auth';

// Token hand-off: a deep link from Vaarta (the chatbot's "Open / Edit & Customize"
// button on a dashboard artifact) can carry `?vaarta_sso=<token>`. It no longer
// admits anyone — this app has no sign-in — but it is still worth keeping: it is
// the platform bearer forwarded on data reads, so a board opened this way can
// fetch from sources the platform still wants a credential for. Stored before the
// providers mount so the first request already carries it, then stripped from the
// URL via history.replaceState so it never lingers in the address bar or history.
(function bootstrapVaartaSso() {
  const params = new URLSearchParams(window.location.search);
  const ssoToken = params.get('vaarta_sso');
  if (!ssoToken) return;
  storeToken(ssoToken);
  params.delete('vaarta_sso');
  const query = params.toString();
  const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
  window.history.replaceState(null, '', cleanUrl);
})();

const queryClient = createQueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary subject="Analytics">
      <AppProviders queryClient={queryClient}>
        <App />
      </AppProviders>
    </ErrorBoundary>
  </React.StrictMode>,
);
